// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2nrRn","noInteraction":"EventWrapper_noInteraction__bqFv0","pointerPassthrough":"EventWrapper_pointerPassthrough__3R5-k"};